module.exports = __webpack_public_path__ + "4aa6e15fc4951e9b889c0cf9da9abd1c.svg";


//////////////////
// WEBPACK FOOTER
// ./images/close-x.svg
// module id = 430
// module chunks = 0